import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';
import gsap from 'gsap';

interface NextCaseRefs {
  elementRef?: RefObject<HTMLElement | null>;
  contentRef?: RefObject<HTMLElement | null>;
  wrapperRef?: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: NextCaseRefs,
): void {
  if (elementRef?.current) {
    timeline.fromTo(elementRef.current, {}, {});
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { contentRef }: NextCaseRefs,
): void {
  if (contentRef?.current) {
    timeline.add(fadeTo(contentRef.current as HTMLElement));
  }
}

export function showLoader(loaderRef: RefObject<HTMLDivElement | null>): void {
  if (loaderRef?.current) {
    gsap.fromTo(loaderRef.current, { scaleX: 0 }, { duration: 0.2, scaleX: 1 });
    gsap.to(loaderRef.current, { duration: 0.2, xPercent: 100, delay: 0.2 });
  }
}

// export function setupScrollOut(
//   timeline: gsap.core.Timeline,
//   { wrapperRef }: NextCaseRefs,
// ): void {
//   if (wrapperRef?.current) {
//     timeline.fromTo(wrapperRef.current, {yPercent: 0}, {yPercent: 200, duration: 1});
//   }
// }
